import { render, staticRenderFns } from "./VueRepeaterBlockLocal.vue?vue&type=template&id=2ae54ae3&scoped=true&"
import script from "./VueRepeaterBlockLocal.vue?vue&type=script&lang=js&"
export * from "./VueRepeaterBlockLocal.vue?vue&type=script&lang=js&"
import style0 from "./VueRepeaterBlockLocal.vue?vue&type=style&index=0&id=2ae54ae3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae54ae3",
  null
  
)

export default component.exports